var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Edit",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#414141",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-copy-2",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2681818,2.1 L11.9,0.731818182 C11.6136364,0.445454545 11.2,0.254545455 10.7863636,0.254545455 C10.3727273,0.254545455 9.95909091,0.413636364 9.67272727,0.731818182 L0.986363636,9.38636364 C0.954545455,9.41818182 0.954545455,9.45 0.922727273,9.48181818 C0.922727273,9.48181818 0.922727273,9.51363636 0.922727273,9.51363636 C0.922727273,9.51363636 0.922727273,9.54545455 0.922727273,9.54545455 L0.286363636,13.3636364 C0.254545455,13.4590909 0.318181818,13.5545455 0.381818182,13.65 C0.445454545,13.7136364 0.509090909,13.7454545 0.604545455,13.7454545 C0.636363636,13.7454545 0.636363636,13.7454545 0.668181818,13.7454545 L4.48636364,13.1090909 C4.48636364,13.1090909 4.51818182,13.1090909 4.51818182,13.1090909 C4.51818182,13.1090909 4.55,13.1090909 4.55,13.1090909 C4.58181818,13.1090909 4.61363636,13.0772727 4.64545455,13.0454545 L13.3,4.39090909 C13.9045455,3.75454545 13.9045455,2.73636364 13.2681818,2.1 Z M2.32272727,12.7909091 L1.17727273,11.6454545 L1.4,10.2454545 L3.72272727,12.5681818 L2.32272727,12.7909091 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f60d36cd3710fcc33b9298132a8c759b.svg";
export { ForwardRef as ReactComponent };